/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {NgForOf} from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {NbButtonModule, NbCardModule, NbIconModule, NbInputModule, NbSpinnerModule} from '@nebular/theme';
import {BaseComponent, DamElasticDTO, DamItemVersion, PageApiResponse} from 'compob2b-libs';
import {catchError, debounceTime, take, takeUntil, tap} from 'rxjs/operators';
import {SecuredImageComponent} from '../secured-image/secured-image.component';
import {translations} from '../../../../environments/translations.ru'

@Component({
    selector: 'app-dam-search-modal',
    templateUrl: './dam-search-modal.component.html',
    styleUrls: ['dam-search-modal.component.scss'],
    imports: [
      ReactiveFormsModule,
      NbSpinnerModule,
      NbInputModule,
      NbButtonModule,
      NbIconModule,
      NbCardModule,
      NgForOf,
      SecuredImageComponent,
    ],
})
export class DamSearchModalComponent extends BaseComponent implements OnInit {

  @Input() uri: string;
  @Input() modelId: number;
  @Input() damRelatedCollectionId: number;

  @Output()
  reloadCollection = new EventEmitter();
  keyword = '';
  damItem: DamElasticDTO;
  damItems: DamElasticDTO[] = [];
  damItemVersions: DamItemVersion[] = [];
  searchControl: FormControl = new FormControl();
  inputFormControl: FormControl;

  ngOnInit(): void {
    this.searchControl.valueChanges
      .pipe(
        tap(_=> console.log('searching')),
        tap(_ => this.loading = true),
        debounceTime(600),
        takeUntil(this.unsubscribe)
      )
      .subscribe(value => {
        this.searchByKeyword(value);
      });
  }

  searchByKeyword(keyword: string) {
    this.keyword = '';
    this.damItem = null;
    this.damItems = [];
    this.damItemVersions = [];

    if (keyword?.length > 1) {
      console.log('searching')
      this.compoApiService
        .get<PageApiResponse<DamElasticDTO[]>>('/dam/files/0/page/0/30/header/asc/?keyword=' + keyword)
        .pipe(take(1), catchError(err => this.handleError(err)))
        .subscribe(response => {
            this.loading = false;
            this.keyword = keyword;
            this.damItems = response.data.content;
            this.damItemVersions = [];
            this.cdr.detectChanges();
          }
        );
    } else {
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  showVersionOfDamItem(damItem: DamElasticDTO) {
    this.damItem = damItem;
    if (damItem) {
      this.compoApiService
        .get<DamItemVersion[]>('/dam/' + damItem.id + '/versions')
        .pipe(take(1), catchError(err => this.handleError(err)))
        .subscribe(response => {
            this.damItemVersions = response.data;
            this.cdr.detectChanges();
          }
        );
    }
  }

  selectDamItemVersion(damItemVersionId: number) {
    this.compoApiService.post(this.uri + '/dam-collection-create-relation/', {
      damItemVersionId,
      modelId: this.modelId,
      damRelatedCollectionId: this.damRelatedCollectionId
    })
      .pipe(take(1), catchError(err => this.handleError(err)))
      .subscribe(() => {
        this.reloadCollection.emit();
        this.successToast('Связь добавлена в коллекцию');
        this.damItemVersions = [];
        this.cdr.detectChanges();
      });
  }

  protected readonly translations = translations
}
